import React, { useEffect, useState } from "react";
import { apiGet, apiPost, apiDelete } from "../lib/api";
import QuestionView from "../components/QuestionView";
import MotionButton from "../components/motion/MotionButton";
import { Star } from "lucide-react";

export default function Favorites() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [loading, setLoading] = useState(true);
  const [favIds, setFavIds] = useState(new Set());

  const load = async () => {
    setLoading(true);
    const r = await apiGet("/favorites");
    setItems(r);
    setFavIds(new Set(r.map((i) => i.question_id)));
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const toggleFav = async (qid, want) => {
    if (want) {
      await apiPost(`/favorites/${qid}`);
      setFavIds((p) => new Set([...p, qid]));
    } else {
      await apiDelete(`/favorites/${qid}`);
      setFavIds((p) => { const n = new Set(p); n.delete(qid); return n; });
      setItems((p) => p.filter((q) => q.question_id !== qid));
      setIdx((i) => Math.max(0, Math.min(i, items.length - 2)));
    }
  };

  if (loading) return <div className="p-8 text-brand-secondary">Caricamento...</div>;

  return (
    <div className="px-6 sm:px-10 py-8 lg:py-12 max-w-4xl mx-auto">
      <div className="mb-7">
        <div className="eyebrow">// Le mie domande</div>
        <h1 className="heading-display text-4xl sm:text-5xl text-brand-primary mt-1 flex items-center gap-3">
          <Star className="h-8 w-8 text-brand-gold fill-brand-gold/20" />
          Preferiti
        </h1>
        <p className="text-base text-brand-secondary mt-2">Domande salvate per il ripasso veloce.</p>
      </div>
      {items.length === 0 ? (
        <div className="border-2 border-dashed border-brand-border rounded-2xl p-12 text-center text-brand-secondary bg-brand-surface">
          Nessuna domanda salvata. Aggiungi una stella per iniziare.
        </div>
      ) : (
        <>
          <div className="text-sm text-brand-secondary mb-3">
            Domanda {idx + 1} di {items.length}
          </div>
          <QuestionView
            question={items[idx]}
            mode="training"
            isFavorite={favIds.has(items[idx].question_id)}
            onToggleFavorite={toggleFav}
            showNext={false}
          />
          <div className="mt-5 flex justify-between">
            <MotionButton data-testid="fav-prev-btn" variant="secondary" disabled={idx === 0} onClick={() => setIdx((i) => i - 1)}>
              Precedente
            </MotionButton>
            <MotionButton data-testid="fav-next-btn" variant="primary" disabled={idx >= items.length - 1} onClick={() => setIdx((i) => i + 1)}>
              Successiva
            </MotionButton>
          </div>
        </>
      )}
    </div>
  );
}
